export default "__VITE_ASSET__BN6IB945__"